var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-row h-6" },
    [
      _c("CardBodySingleChip", {
        attrs: {
          label: "Task:",
          customContainerClass: "-mt-0.5",
          clickableText: true,
          labelStyle: "text-blue font-outfit text-xs font-normal w-max-content",
          chipDetails: _vm.activityChipDetails
            ? _vm.activityChipDetails
            : `n/a`,
        },
      }),
      _c("CardBodySingleChip", {
        attrs: {
          label: "Client:",
          clickableText: true,
          customContainerClass: "-mt-0.5",
          labelStyle: "text-blue font-outfit text-xs font-normal w-max-content",
          chipDetails: _vm.projectChipDetails ? _vm.projectChipDetails : `n/a`,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }